<template>
  <div class="risk-form">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>Ação proposta</label>
            <textarea
              v-model="action_plan.improvement_action.description"
              class="form-control"
              id
              rows="5"
              disabled
            ></textarea>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label>
              Ações executadas
              <span>*</span>
            </label>
            <textarea
              v-model="action_plan.taken_action"
              rows="5"
              class="form-control"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>
              Avaliação de risco com ações de melhoria
              <span>*</span>
            </label>
            <input
              v-if="renderRiskAfterChange"
              type="text"
              class="form-control"
              v-model="action_plan.risk_after_change"
              disabled
            />
          </div>
        </div>
        <!-- <div class="col-6" style="display: hidden">
          <div class="form-group">
            <label>Responsável</label>
            <input type="text" class="form-control" value="João Claudio" disabled />
          </div>
        </div>-->
      </div>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label>
              Prazo de execução
              <span v-if="required('deadline')">*</span>
            </label>
            <b-form-datepicker
              v-model="action_plan.deadline"
              placeholder="Escolha uma data"
              class="mb-2"
            ></b-form-datepicker>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label for>
              Investimento para adequação
              <span v-if="required('investment_amount')">*</span>
            </label>
            <currency-input
              v-model="action_plan.investment_amount"
              :currency="{ prefix: 'R$ ' }"
              locale="de"
              class="form-control"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label for>
              Budget Liberado
              <span v-if="required('is_budged_released')">*</span>
            </label>
            <select
              v-model="action_plan.is_budged_released"
              class="form-control"
            >
              <option value="1">Sim</option>
              <option value="0">Não</option>
            </select>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label for>
              Compra realizada
              <span v-if="required('is_purchase_realised')">*</span>
            </label>
            <select
              v-model="action_plan.is_purchase_realised"
              class="form-control"
            >
              <option value="1">Sim</option>
              <option value="0">Não</option>
            </select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label for>
              Fornecedor
              <span v-if="required('manufacturer')">*</span>
            </label>
            <input
              v-model="action_plan.manufacturer"
              type="text"
              class="form-control"
            />
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label for>
              Comentários
              <span v-if="required('comment')">*</span>
            </label>
            <input
              v-model="action_plan.comment"
              type="text"
              class="form-control"
            />
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label>Referências Normativas</label>
            <!-- <multiselect
              v-model="selectedReferences"
              :multiple="true"
              :options="references"
              track-by="id"
              label="code"
              placeholder="Selecione normativas"
            ></multiselect>-->
            <input
              v-model="action_plan.improvement_action.ref_number"
              class="form-control"
            />
          </div>
        </div>

        <div class="col-12">
          <label>Status</label>
        </div>
        <div class="col-12">
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              :name="'status_'+ action_plan.improvement_action.id"
              :id="'status-executada_' + action_plan.improvement_action.id"
              value="Executada"
              v-model="action_plan.status"
            />
            <label class="form-check-label" :for="'status-executada_' + action_plan.improvement_action.id"
              >Executada</label
            >
          </div>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              :name="'status_'+ action_plan.improvement_action.id"
              :id="'status-pendente_' + action_plan.improvement_action.id"
              value="Pendente"
              v-model="action_plan.status"
            />
            <label class="form-check-label" :for="'status-pendente_' + action_plan.improvement_action.id"
              >Pendente</label
            >
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <button class="btn btn-success float-right" v-on:click="save()">
            <span>Salvar Ação de Melhoria <font-awesome-icon icon="save" /> </span>
          </button>
        </div>
        <!-- <div class="col-6">
          <div class="iconContainer h-100 w-100">
            <div class="icon" v-on:click="openModal('delete-modal')">
              <font-awesome-icon icon="trash" />
            </div>
            <div class="icon" style="display:none">
              <font-awesome-icon icon="print" />
            </div>
          </div>
        </div>-->
      </div>
      <div class="row">
        <div class="col-12 col-padding">
          <b-alert v-show="alert" :variant="alert_type" show>{{
            alert_msg
          }}</b-alert>
          <b-alert v-show="alert_field" :variant="alert_field_type" show>{{
            alert_field_msg
          }}</b-alert>
        </div>
      </div>
    </div>

    <b-modal
      ref="delete-modal"
      title="Excluir Plano de Ação"
      modal-ok="Sim"
      modal-cancel="Não"
      @ok="deleteActionPlan()"
    >
      Tem certeza que deseja apagar este item?
      <template v-slot:modal-cancel>Não</template>
      <template v-slot:modal-ok>Sim</template>
    </b-modal>
  </div>
</template>
<script>
import axios from "@/api/axios";
import moment from "moment";
import { required } from "vuelidate/lib/validators";

export default {
  name: "risk-form",
  props: {
    action_plan: { taken_action: "", deadline: "", risk_after_change: "", status: "Pendente" },
    analyze_action_plan_id: String,
    index: Number,
  },
  components: {},
  data() {
    return {
      item: {},
      hrnLevel: "",
      references: [],
      selectedReferences: [],
      alert: false,
      alert_type: "success",
      alert_msg: "Item salvo com sucesso",
      alert_field: false,
      alert_field_type: "success",
      alert_field_msg: "Item salvo com sucesso",
      submited: false,
      teste: false,
      tmp: "",
      checkMade: false,
      renderRiskAfterChange: false,
    };
  },
  mounted() {
    this.initComponent();
    // setTimeout(() => {
    //   this.getReferences();
    // }, 350);

    // this.action_plan.hazard.improvement_actions.forEach((improvement_action) =>
    // this.selectedReferences.push(improvement_action.ref_number));
  },
  validations: {
    action_plan: {
      taken_action: {
        required,
      },
      risk_after_change: {
        required,
      },
      deadline: {},
      investment_amount: {},
      investment_currency: {},
      is_budged_released: {},
      is_purchase_realised: {},
      manufacturer: {},
      comment: {},
    },
  },
  methods: {
    initComponent: function () {
      this.action_plan.deadline =
        this.action_plan.deadline &&
        this.action_plan.deadline.split(" ").length > 1
          ? this.action_plan.deadline.split(" ")[0]
          : this.action_plan.deadline;

      this.action_plan.proposed_action = this.action_plan.hazard
        ? this.action_plan.hazard.improvement_action
        : "";

      this.action_plan.is_budged_released =
        typeof this.action_plan.is_budged_released == "boolean"
          ? this.action_plan.is_budged_released
            ? 1
            : 0
          : this.action_plan.is_budged_released;

      this.action_plan.is_purchase_realised =
        typeof this.action_plan.is_purchase_realised == "boolean"
          ? this.action_plan.is_purchase_realised
            ? 1
            : 0
          : this.action_plan.is_purchase_realised;

      const parsedInvestment = parseFloat(this.action_plan.investment_amount);
      this.action_plan.investment_amount = isNaN(parsedInvestment)
        ? 0
        : parsedInvestment;

      // ✅ Exibir diretamente o HRN calculado vindo da API
      const hrn = this.action_plan.hazard?.hrn;
      if (hrn) {
        this.action_plan.risk_after_change = hrn.hrn_improvement_level;
        this.renderRiskAfterChange = true;
      } else {
        this.action_plan.risk_after_change = "";
        this.renderRiskAfterChange = false;
      }

      if (this.action_plan.nr_references) {
        for (let i = 0; i < this.action_plan.nr_references.length; i++) {
          this.selectedReferences.push(this.action_plan.nr_references[i]);
        }
      }
    },

    calculateHRN: function () {
      if (this.action_plan.hazard)
        axios
          .post(`${process.env.VUE_APP_API_HOST}/api/admin/calculate-hrn`, {
            np: this.action_plan.hazard.improvement_score_np,
            dph: this.action_plan.hazard.improvement_score_dph,
            fe: this.action_plan.hazard.improvement_score_fe,
            lo: this.action_plan.hazard.improvement_score_lo,
          })
          .then((response) => {
            this.action_plan.risk_after_change = response.data.hrnLevel;
            this.renderRiskAfterChange = true;
          });
    },
    save: function () {
      this.submited = true;
      // this.check();
      // if (this.checkMade == false) {
      if (this.action_plan.id) {
        this.update();
        return true;
      }
      axios
        .post(`${process.env.VUE_APP_API_HOST}/api/admin/action-plans/`, {
          action_plan_analyze_id: this.analyze_action_plan_id,
          improvement_action_id: this.action_plan.improvement_action.id,
          taken_action: this.action_plan.taken_action,
          risk_after_change: this.action_plan.risk_after_change,
          deadline: this.action_plan.deadline,
          investment_amount: this.action_plan.investment_amount,
          investment_currency: "BRL",
          is_budged_released: this.action_plan.is_budged_released,
          is_purchase_realised: this.action_plan.is_purchase_realised,
          manufacturer: this.action_plan.manufacturer,
          comment: this.action_plan.comment,
          references: this.selectedReferences,
          status: this.action_plan.status
        })
        .then((response) => {
          this.saving = false;
          // if (response.id) {
          let tmp = this.action_plan.hazard;
          response.data.deadline != null
            ? response.data.deadline.split(" ")[0]
            : response.data.deadline;
          this.action_plan = response.data;
          this.action_plan.hazard = tmp;
          this.alert_type = "success";
          this.alert_msg = "Item salvo com sucesso";
          this.alert = true;
          this.initComponent();
          this.$emit("saveActionPlan", this.action_plan.id);
          const vm = this;
          setTimeout(() => {
            vm.alert = false;
          }, 3000);
          // } else {
          //   this.alert_type = "warning";
          //   this.alert_msg = "Ocorreu um erro";
          //   this.alert = true;
          //   const vm = this;
          //   setTimeout(() => {
          //     vm.alert = false;
          //   }, 3000);
          // }
        })
        .catch(() => {
          this.alert_type = "warning";
          this.alert_msg = "Ocorreu um erro";
          this.alert = true;
          const vm = this;
          setTimeout(() => {
            vm.alert = false;
          }, 3000);
        });
      // }
    },
    update: function () {
      let selectedReferencesId = [];
      for (var i = 0; i < this.selectedReferences.length; i++) {
        selectedReferencesId.push(this.selectedReferences[i].id);
      }
      axios
        .put(
          `${process.env.VUE_APP_API_HOST}/api/admin/action-plans/` +
            this.action_plan.id,
          {
            action_plan_analyze_id: this.analyze_action_plan_id,
            improvement_action_id: this.action_plan.improvement_action.id,
            taken_action: this.action_plan.taken_action,
            risk_after_change: this.action_plan.risk_after_change,
            deadline: this.action_plan.deadline,
            investment_amount: this.action_plan.investment_amount,
            investment_currency: "BRL",
            is_budged_released: this.action_plan.is_budged_released,
            is_purchase_realised: this.action_plan.is_purchase_realised,
            manufacturer: this.action_plan.manufacturer,
            comment: this.action_plan.comment,
            references: selectedReferencesId,
            status: this.action_plan.status
          }
        )
        .then((response) => {
          this.saving = false;
          // if (response.id) {
          let tmp = this.action_plan.hazard;
          response.data.deadline != null
            ? response.data.deadline.split(" ")[0]
            : response.data.deadline;
          this.action_plan = response.data;
          this.action_plan.hazard = tmp;
          this.alert_type = "success";
          this.alert_msg = "Item salvo com sucesso";
          this.alert = true;
          this.initComponent();
          const vm = this;
          setTimeout(() => {
            vm.alert = false;
          }, 3000);
          // } else {
          //   this.alert_type = "warning";
          //   this.alert_msg = "Ocorreu um erro";
          //   this.alert = true;
          //   const vm = this;
          //   setTimeout(() => {
          //     vm.alert = false;
          //   }, 3000);
          // }
        })
        .catch((error) => {
          this.alert_type = "warning";
          this.alert_msg = "Ocorreu um erro" + error;
          this.alert = true;
          const vm = this;
          setTimeout(() => {
            vm.alert = false;
          }, 3000);
        });
    },
    showError: function (attribute) {
      this.tmp = attribute;
      return false;
      // return this.$v.action_plan[attribute].$invalid && this.submited;
    },
    required: function (attribute) {
      this.tmp = attribute;
      return false;
      // return this.$v.action_plan[attribute].$params.required;
    },
    openModal: function (modal) {
      this.$refs[modal].show();
    },
    check: function () {
      this.checkMade = false;
      var now = moment().format("YYYY-MM-DD");
      if (
        this.action_plan.taken_action == "" ||
        this.action_plan.risk_after_change == ""
      ) {
        this.alert_field_type = "warning";
        this.alert_field_msg = "Por favor, preencha os campos obrigatórios";
        this.alert_field = true;
        const vm = this;
        setTimeout(() => {
          vm.alert_field = false;
        }, 3000);
        this.checkMade = true;
      }
      if (moment(this.action_plan.deadline).isBefore(now)) {
        this.alert_field_type = "warning";
        this.alert_field_msg = "Por favor, escolha uma data válida";
        this.alert_field = true;
        const vm = this;
        setTimeout(() => {
          vm.alert_field = false;
        }, 3000);
        this.checkMade = true;
      }
    },

    validate: function () {
      for (let property in this.action_plan) {
        if (this.required(property) && this.action_plan[property]) {
          return false;
        }
      }
      return true;
    },
    deleteActionPlan: function () {
      if (this.action_plan.id) {
        axios
          .delete(
            `${process.env.VUE_APP_API_HOST}/api/admin/action-plans/${this.action_plan.id}`
          )
          .then(() => {
            this.$emit("deleteActionPlan", this.index);
          });
      } else {
        this.$emit("deleteActionPlan", this.index);
      }
    },
    getReferences: function () {
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/admin/get-all-references/`)
        .then((response) => {
          this.references = response.data;
        });
    },
  },
};
</script>

<style lang="scss">
@import "src/styles/General.scss";
@import "node_modules/bootstrap/scss/bootstrap";
@import "node_modules/bootstrap-vue/src/index.scss";

.iconContainer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .icon {
    margin-left: 10px;
    height: 100%;
    width: 40px;
    border: 1px solid gray;
    border-radius: 7px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .icon:hover {
    cursor: pointer;
    background-color: #d0d2d8;
    color: white;
    border: 1px solid #d0d2d8;
  }
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
